import { useTranslation } from 'react-i18next';
import React, { useMemo } from 'react';
import { Table } from 'antd';
import useDatasource from '../../../../hooks/useDatasource';
import Column from '../../../../helpers/columns';
import EditItemIcon from '../../../../components/buttons/EditItemIcon';
import DeleteItemIcon from '../../../../components/buttons/DeleteItemIcon';
import {
  deleteCouncilDecisionReport,
  searchCouncilDecisionsReports,
} from '../../../../services/taxonomies/council-decision-report';
import { Default } from '../../../../layouts';
import PageTitle from '../../../../components/PageTitle';
import AddEntityButton from '../../../../components/buttons/AddEntityButton';
import ViewItemIcon from '../../../../components/buttons/ViewItemIcon';
import usePermissions from '../../../../hooks/usePermission';

const permissionsMap = {
  canView: ['ADMINISTRATION_TAXONOMIES_VIEW_PERMISSION'],
  canEdit: ['SYS_SUPERUSER', 'TAXONOMIES_PERMISSION'],
  canDelete: ['SYS_SUPERUSER', 'TAXONOMIES_PERMISSION'],
};

const CouncilDecisionReportList = () => {
  const { t } = useTranslation();

  const { canView, canEdit, canDelete } = usePermissions(permissionsMap);

  const { pagination, content, handleChange, reload } = useDatasource(
    searchCouncilDecisionsReports,
  );

  const columns = useMemo(
    () => [
      Column.text(
        'reportName',
        t('entity.taxonomy.councilDecisionReport.reportName'),
        {
          filter: true,
        },
      ),
      Column.date(
        'startDate',
        t('entity.taxonomy.councilDecisionReport.startDate'),
        {
          filter: true,
          format: 'YYYY-MM-DD',
        },
      ),
      Column.date(
        'endDate',
        t('entity.taxonomy.councilDecisionReport.endDate'),
        {
          filter: true,
          format: 'YYYY-MM-DD',
        },
      ),
      Column.bool(
        'deleted',
        t('entity.taxonomy.councilDecisionReport.deleted._'),
        {
          filter: true,
          inverted: true,
          labels: [
            t('table.filter.all'),
            t('entity.taxonomy.councilDecisionReport.deleted.true'),
            t('entity.taxonomy.councilDecisionReport.deleted.false'),
            t('table.filter.unknown'),
          ],
        },
      ),
      Column.actions(t('table.actions'), (councilDecisionReport) => (
        <>
          {canView && (
            <ViewItemIcon
              path={`/admin/taxonomies/council-decisions-reports/${councilDecisionReport.id}`}
            />
          )}
          {canEdit && (
            <EditItemIcon
              path={`/admin/taxonomies/council-decisions-reports/${councilDecisionReport.id}`}
            />
          )}
          {canDelete && (
            <DeleteItemIcon
              title={t(
                'entity.taxonomy.councilDecisionReport._delete',
                councilDecisionReport,
              )}
              message={t(
                'entity.taxonomy.councilDecisionReport._deleted',
                councilDecisionReport,
              )}
              item={councilDecisionReport}
              action={deleteCouncilDecisionReport}
              reload={reload}
            />
          )}
        </>
      )),
    ],
    [t, canView, canEdit, canDelete, reload],
  );

  return (
    <Default>
      <PageTitle title={t('entity.taxonomy.councilDecisionReport._plural')}>
        <AddEntityButton
          entity={t('entity.taxonomy.councilDecisionReport._singular')}
          path="/admin/taxonomies/council-decisions-reports/new"
        />
      </PageTitle>
      <Table
        columns={columns}
        rowKey="id"
        // loading={loading}
        pagination={pagination}
        dataSource={content}
        scroll={{ x: 700, y: 700 }}
        onChange={handleChange}
      />
    </Default>
  );
};

export default CouncilDecisionReportList;
